export default {
  payWelfareText: 'Бонусы пополнения',
  blackFridayDiscount: 'Скидка Чёрной пятницы',
  shareGift: 'Дружеский подарок',
  vipWeeklyWelfare: 'Недельная скидка VIP',
  exchangeCoupon: 'Купон',
  firstPayOff: 'Скидка до 15% на первую покупку',
  blackFridayEvent: 'Событие Чёрной пятницы',
  limitedTimeOff: 'Особая 10% скидка',
  claimCoupon: 'Получить сейчас',
  blackFridayTimedCoupon: 'Купон Чёрной пятницы',
  timeLeft: 'Осталось:',
  claimTimeCoupon: 'Получите особую 10% скидку!',
  points: 'Пункты: ${point}',
  costPointTip: 'Обменивайте пункты на купоны',
  maxPointTip: 'На аккаунте можно использовать до 500 пунктов.',
  discountOff: 'СКИДКА 10%',
  highestDiscount: 'Скидка до ${discount} ',
  needPoint: 'Нужно ${point} пунктов',
  changeCurrency: 'Сменить валюту',
  claim: 'Получить',
  claimSucc: 'Получено',
  claimFail: 'Неудача',
  pointNotEnough: 'Недостаточно пунктов',
  afterClaimPoint: 'Осталось пунктов: ${point}',
  footTips1: 'На каждый заказ применяется только 1 купон.',
  footTips2: 'Купоны не применяются для покупки игровой валюты/жетонов.',
  footTips3:
    'Мы оставляем за собой право окончательной трактовки правил данного события.',
  ruleTitleText: 'Правила события',
  ruleTime:
    'Время события: с [00:00] 24 ноября 2023 до [23:59] 26 ноября 2023 (UTC)',
  bfRuleText1:
    '1. После первого посещения официальной страницы пополнения счета во время события вам будет начислено 400 пунктов. Можно будет обменять на купоны до 500 пунктов.',
  bfRuleText2:
    '2. Во время события вы можете обменять очки Чёрной пятницы на купоны.',
  bfRuleText3:
    '3. На каждый заказ применяется только 1 купон. Купоны не применяются для покупки игровой валюты/жетонов.',
  bfRuleText4: '4. Для транзакций доступны следующие валюты:',
  ableCoinsType: '/',
  bfRuleText5:
    '5. После выполнения транзакции вы не сможете поменять валюту. Обмененные пункты не возмещаются.',
  bfRuleText6: '6. Купоны Чёрной пятницы действительны в течение 7 дней.',
  bfRuleText7:
    '7. Мы оставляем за собой право окончательной трактовки правил данного события.',
  thanksTip:
    'Спасибо за участие. Больше информации вы сможете получить, посетив наше официальное сообщество.',
  exchangePoints: 'Обмен',
  exchangeCode: 'Введите код обмена.',
  enterExchangeCode: 'Введите код обмена.',
  exchangeText: 'Обмен',
  confirmGet: 'Принять',
  couponUsedWay:
    'Купон можно обменять только с определёнными валютами, подтвердите валюту.',
  confirmText: 'Принять',
  exchangeSucc: 'Обменено',
  aboutCoins: 'Об игровой валюте/жетонах',
  aboutCoinsText:
    'Вы можете обменять игровую валюту/жетоны на любые наборы и привилегии, исключая игровую валюту/жетоны.',
  known: 'Принять',
  codeText: 'Код',
  codeInvalid: 'Неверный код!',
  hasExchanged: 'Больше нельзя получить коды.',
  hideText: 'Скрыть',
  //黑五的报错码
  'bf-20001': 'Вход не выполнен',
  'bf-20002': 'Ошибка параметра. Пожалуйста, попробуйте перезапустить событие.',
  'bf-20003': 'Недостаточно пунктов',
  'bf-20004': 'Неудача! Повторите попытку или напишите в службу поддержки.',
  'bf-20005': 'Получено',
  'bf-20015': 'Событие в данный момент недоступно.',
  'bf-20016': 'Событие завершилось.',
  bfShareText: 'Получите особую 10% скидку!',
  rightsCenterBtn: 'Центр Премиум участников',
  payBtn: 'ПОКУПКУ',
  hasEqualRewardMuglo: 'До 1800 БОНУСНЫХ алмазов за покупки на официальном сайте!',
  productInterceptPopupTitle: 'Покупка не выполнена',
  productInterceptPopupTip: 'Система недоступна в вашем регионе.<br>Если у вас остались вопросы, пожалуйста, обратитесь в службу поддержки.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Великий и необычный (Навсегда)',
  rightCenterNoticeTitle: 'Система VIP-очков преобразуется в Центр привилегий',
  rightCenterNoticeContent: 'Здравствуйте, Командир!<br />Благодарим за поддержку «Puzzles & Survival». Чтобы сделать получение наград удобнее, 16 июля 2025 текущая система VIP-очков будет преобразована в Центр Премиум участников. Эта новая система не только объединит существующие VIP-бонусы, но и добавит множество новых. Вам будет полезно знать:<br />1. Что изменится?<br />Еженедельные бонусы за вход остаются<br />С 16 июля по 29 июля 2025 года игроки по-прежнему смогут получать еженедельные VIP-купоны, посещая официальную страницу пополнения счёта. Количество купонов останется таким же, как и в рамках события с VIP-очками. Кроме того, игроки смогут обменять новые купоны в Центре Премиум участников, где будет действовать максимальная скидка. Подробную информацию о новых правилах использования купонов и ограничениях на их обмен смотрите в таблице в конце этого уведомления.<br />Примечание: автоматическое применение купонов нужно включить вручную. Для этого перейдите: Главная страница Центра привилегий > Бонусы участника > Автопогашение купонов > Выберите купоны для автоматического использования > Подтвердить.<br />Новая функция обмена очков<br />В Центре привилегий появится функция обмена очков. Зарабатывайте очки за вход в игру или за выполнение заданий, а затем обменивайте их на эксклюзивные купоны, редкие предметы и другие ценные награды. (Ограничения на обмен предметов смотрите на странице Центра привилегий.)<br />Наследование VIP-статуса<br />Ваш текущий VIP-уровень и накопленные VIP-очки будут полностью перенесены в новую систему. Вы автоматически получите соответствующий уровень в Центре привилегий, а все ваши текущие VIP-бонусы будут сохранены и даже улучшены.<br />2. Преимущества обновления<br />Прозрачные преимущества: все правила получения и использования наград теперь предельно понятны. Получать бонусы стало проще!<br />Ценные награды: вас ждут новые акции обмена очков и регулярное обновление списка ценных предметов.<br />Лотереи: помимо обмена очков, будут проводиться лотереи с ценными игровыми призами.<br />3. Важное<br />В переходный период (с 16 июля по 29 июля 2025 г.) раздел с VIP-очками будет постепенно убран. В это время купоны можно будет получать и использовать как обычно. Не забудьте потратить имеющиеся купоны до окончания акции VIP-очков, поскольку неиспользованные купоны сгорят.<br />Центр привилегий будет доступен по адресу: Центр пополнения счета > Ваш аватар > Центр привилегий.',
  rightCenterNoticeTableTitle: 'Сравнение изменений купонов',
  rightCenterNoticeTableHeader1: 'Требования к обмену – уровень Премиум участника',
  rightCenterNoticeTableHeader2: 'Исходный VIP-уровень',
  rightCenterNoticeTableHeader3: 'Купонная скидка',
  rightCenterNoticeTableHeader4: 'Лимит получения',
  rightCenterNoticeTableHeader5: 'Максимальная скидка',
  rightCenterNoticeTableLevel1: 'Бронза',
  rightCenterNoticeTableLevel2: 'Серебро', 
  rightCenterNoticeTableLevel3: 'Золото',
  rightCenterNoticeTableLevel4: 'Платина',
  rightCenterNoticeTableLevel5: 'Алмаз',
  rightCenterNoticeTableCount1: 'Раз в день',
  rightCenterNoticeTableCount2: '15 раз/мес.',
  rightCenterNoticeTableCount3: '10 раз/мес.',
  rightCenterNoticeTableLimit: '$15',
  rightCenterNoticeTableTip: 'Обратите внимание: купонная скидка в Центре привилегий рассчитывается в долларах США и может меняться в зависимости от курса валют. Фактический размер скидки будет отображаться на странице использования.',
  '-': '-'
};
